module.exports = __webpack_public_path__ + "img/Weapon_95.9b3f0702.png";